import type { Font } from '@st/sdk'
import { match } from '@st/pattern'
import fieldFonts from '../../../../../../../static_data/contracts/field_fonts.json'

// Shared with Codex.Contracts.Rendering.FieldFonts so the signing preview and
// the signed PDF draw completed fields with one font policy.
export const signerFieldFonts = fieldFonts as Record<'label' | 'signature' | 'value', Font>

export const signerFieldShape =
  'flex items-center rounded border px-2 text-left text-xs font-semibold'

export function signerFieldAppearance(signerRole: string) {
  return match(signerRole)
    .with('spouse', () => ({
      field: 'border-[#8cb222] bg-[#8cb222]/20 text-[#617b17]',
      hover: 'hover:bg-[#8cb222]/30',
      selected: 'ring-[#8cb222]'
    }))
    .otherwise(() => ({
      field: 'border-[#536cf1] bg-[#536cf1]/20 text-[#4054c5]',
      hover: 'hover:bg-[#536cf1]/30',
      selected: 'ring-[#536cf1]'
    }))
}

export function signerFieldAriaLabel(signerRole: string, fieldType: 'signature' | 'date') {
  const role = `${signerRole.charAt(0).toUpperCase()}${signerRole.slice(1)}`
  return `${role} ${fieldType}`
}
